var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98213 0.808594L6.71684 1.24938C7.75628 1.87298 8.40699 2.76011 8.74736 3.66708C8.87686 3.37477 9.03068 3.09235 9.1736 2.8065L9.74585 3.37879C11.0304 4.66333 12.25 6.58852 12.25 8.45793C12.25 10.9653 10.7043 12.5546 8.23123 12.8294L7.42045 12.9194L7.59738 12.1231C7.7358 11.5001 7.76024 11.0927 7.73207 10.8076C7.6966 10.4486 7.52598 10.1672 7.31411 9.88703C7.11082 9.61823 6.90986 9.34955 6.74898 9.0524C6.08649 9.57594 5.82985 10.0486 5.74797 10.4375C5.64301 10.9361 5.79169 11.4451 6.0635 11.9887L6.543 12.9478L5.47731 12.8294C3.97471 12.6624 2.49423 11.6587 1.91111 10.1936C1.30133 8.66139 1.73252 6.80686 3.70145 5.10045C5.00831 3.96785 5.70039 2.49968 5.98213 0.808594ZM6.75919 2.73409C6.31469 3.98197 5.4615 5.11893 4.46553 5.98208C2.76731 7.45383 2.61518 8.80763 2.99508 9.76214C3.27823 10.4736 3.88908 11.0589 4.61295 11.3908C4.53615 11.0185 4.5179 10.6171 4.60633 10.1971C4.79618 9.29542 5.44487 8.4504 6.69094 7.67159L7.31919 7.27895L7.55351 7.98181C7.75884 8.59787 8.18497 9.03338 8.5177 9.57407C8.88404 10.1694 8.95409 10.8515 8.88013 11.5335C10.4074 11.1507 11.0834 9.99174 11.0834 8.45793C11.0834 7.16193 10.3017 5.89021 9.52547 4.89618C9.20644 5.61243 8.53223 5.86489 7.87504 6.19343V5.2496C7.87504 4.45104 7.5503 3.47763 6.75919 2.73409Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFire);
export default __webpack_public_path__ + "static/media/icon_fire.1764fa66b8a651cba10498421ab5384e.svg";
export { ForwardRef as ReactComponent };